import Input from 'components/Input'
import { CustomInputFormik } from 'components/formik/formikFormComponents'
import { Form, Formik, useFormikContext } from 'formik'
import { pick } from 'lodash'
import { Save, X } from 'lucide-react'
import { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { clean } from 'utils/clean'
import { showHttpToast } from 'lib/show-toast'
import { PapeletaService } from '../services/papeleta.service'
import { Spinner } from 'components/ui/spinner'

const initialValues = {
    devolucion_terrestre: '',
    devolucion_aereo: '',
    devolucion_viaticos: '',
}
export function PapeletaRefundForm({ papeleta, onCancel, onSuccess }) {
    const [dias, setDias] = useState('')
    const [loading, setLoading] = useState(false)

    const handleSubmit = async (values) => {
        if (papeleta) {
            setLoading(true)
            const { success, message } = await PapeletaService.refund(papeleta.id, {
                devolucion_terrestre: values.devolucion_terrestre || '0',
                devolucion_aereo: values.devolucion_aereo || '0',
                devolucion_viaticos: values.devolucion_viaticos || '0',
            })
            showHttpToast(success, { description: message })
            if (success) {
                onSuccess?.()
            }
            setLoading(false)
        }
    }
    const handleChange = (e) => {
        const value = e.target.value
        if (value.length < 3) {
            setDias(value)
        }
    }

    return (
        <Formik
            onSubmit={handleSubmit}
            validate={(values) =>
                validate({
                    ...values,
                    pasaje_terrestre: papeleta.pasaje_terrestre,
                    pasaje_aereo: papeleta.pasaje_aereo,
                    subtotal_viaticos: papeleta.subtotal_viaticos,
                })
            }
            initialValues={{
                ...initialValues,
                ...clean(pick(papeleta, Object.keys(initialValues))),
            }}
        >
            {() => (
                <Form>
                    <div className='px-3 py-2'>
                        <div className='d-flex flex-column gap-2 mb-3'>
                            <div>Nro. de Papeleta: {papeleta.numero}</div>
                            <div>Beneficiario: {papeleta.beneficiario}</div>
                            <div>Lugar de Viaje: {papeleta.lugar_viaje}</div>
                            <div className='d-flex'>
                                <div className='w-50'>
                                    Pas. Terrestre: Bs. {papeleta.pasaje_terrestre}
                                </div>
                                <div className='w-50'>Pas. Aéreo: Bs. {papeleta.pasaje_aereo}</div>
                            </div>
                            <div className='d-flex'>
                                <div className='w-50'>
                                    Viáticos: Bs. {papeleta.subtotal_viaticos}
                                </div>
                                <div className='w-50'>Días: {papeleta.dias_viaticos}</div>
                            </div>
                        </div>
                        <div className='d-flex flex-column gap-3'>
                            <CustomInputFormik
                                name='devolucion_terrestre'
                                type='currency'
                                label={<div style={{ width: '8rem' }}>Pas. Terrestre:</div>}
                                startIcon='Bs'
                                inline
                                disabled={!(papeleta.pasaje_terrestre * 1)}
                            />
                            <CustomInputFormik
                                name='devolucion_aereo'
                                type='currency'
                                label={<div style={{ width: '8rem' }}>Pas. Aéreo:</div>}
                                startIcon='Bs'
                                inline
                                disabled={!(papeleta.pasaje_aereo * 1)}
                            />
                            <CustomInputFormik
                                name='devolucion_viaticos'
                                type='currency'
                                label={
                                    <div
                                        className='d-flex align-items-center'
                                        style={{ width: '8rem' }}
                                    >
                                        <div className='me-2'>Viáticos:</div>
                                        <Input
                                            value={dias}
                                            onChange={handleChange}
                                            placeholder='Días'
                                            disabled={!(papeleta.viaticos * 1)}
                                        />
                                    </div>
                                }
                                startIcon='Bs'
                                inline
                                disabled={!(papeleta.viaticos * 1)}
                            />
                        </div>
                        <Observer dias={dias} papeleta={papeleta} />
                    </div>
                    <div className='text-end space-x-2 px-3 py-2 border-top'>
                        <Button variant='outline-primary' onClick={onCancel}>
                            <X className='size-4' />
                            Cancelar
                        </Button>
                        <Button type='submit' disabled={loading}>
                            {loading ? <Spinner /> : <Save className='size-4' />}
                            Guardar
                        </Button>
                    </div>
                </Form>
            )}
        </Formik>
    )
}

function Observer({ dias, papeleta }) {
    const { setFieldValue } = useFormikContext()

    useEffect(() => {
        if (dias && dias <= papeleta.dias_viaticos) {
            const devolucion = (papeleta.subtotal_viaticos / papeleta.dias_viaticos) * dias
            setFieldValue('devolucion_viaticos', Math.round(devolucion).toFixed(2))
        } else {
            setFieldValue('devolucion_viaticos', '')
        }
    }, [dias])

    return null
}

function validate(values) {
    const errors = {}
    if (values.pasaje_terrestre * 1 && values.devolucion_terrestre > 1 * values.pasaje_terrestre) {
        errors.devolucion_terrestre = 'La devolución debe ser menor al pasaje terrestre'
    }
    if (values.pasaje_aereo * 1 && values.devolucion_aereo > 1 * values.pasaje_aereo) {
        errors.devolucion_aereo = 'La devolución debe ser menor al pasaje aéreo'
    }
    if (values.subtotal_viaticos * 1 && values.devolucion_viaticos > 1 * values.subtotal_viaticos) {
        errors.devolucion_viaticos = 'La devolución debe ser menor a los viáticos'
    }
    return errors
}
